import request from '@/utils/request'


// 查询加盟合作列表
export function listCooperate(query) {
  return request({
    url: '/cooperate/cooperate/list',
    method: 'get',
    params: query
  })
}

// 查询加盟合作分页
export function pageCooperate(query) {
  return request({
    url: '/cooperate/cooperate/page',
    method: 'get',
    params: query
  })
}

// 查询加盟合作详细
export function getCooperate(data) {
  return request({
    url: '/cooperate/cooperate/detail',
    method: 'get',
    params: data
  })
}

// 新增加盟合作
export function addCooperate(data) {
  return request({
    url: '/cooperate/cooperate/add',
    method: 'post',
    data: data
  })
}

// 修改加盟合作
export function updateCooperate(data) {
  return request({
    url: '/cooperate/cooperate/edit',
    method: 'post',
    data: data
  })
}

// 删除加盟合作
export function delCooperate(data) {
  return request({
    url: '/cooperate/cooperate/delete',
    method: 'post',
    data: data
  })
}
